import { AvailableFeatures } from "../features";

import { COUNTERS_ROUTES } from "./counters-routing";
import { ENGINE_TRENDING_ROUTES } from "./engine-trending-routing";
import { MAINTENANCE_INTELLIGENCE_ROUTES } from "./maintenance-intelligence-routing";
import { ORGANIZATION_MANAGEMENT_ROUTES } from "./organization-management-routes";
import { PERFORMANCE_ROUTES } from "./performance-routing";
import { REPORTS_ROUTES } from "./reports-routing";
import { RISK_ROUTES } from "./risk-routing";
import { SQUAWKS_ROUTES } from "./squawks-routing";
import { SUPPORT_VEHICLE_RISK_ROUTES } from "./support-vehicle-routing";
import { WEIGHT_AND_BALANCE_ROUTES } from "./weight-and-balance-routing";

const FEATURE_TO_ROUTES = {
  [AvailableFeatures.MAINTENANCE_INTELLIGENCE]: MAINTENANCE_INTELLIGENCE_ROUTES,
  [AvailableFeatures.SQUAWKS]: SQUAWKS_ROUTES,
  //   [AvailableFeatures.BINDER]: BINDER_ROUTES,
  [AvailableFeatures.REPORTS]: REPORTS_ROUTES,
  [AvailableFeatures.RISK]: [
    ...RISK_ROUTES,
    ...SUPPORT_VEHICLE_RISK_ROUTES,
  ],
  //   [AvailableFeatures.TRAINING]: TRAINING_ROUTES,
  [AvailableFeatures.WEIGHT_AND_BALANCE]: WEIGHT_AND_BALANCE_ROUTES,
  [AvailableFeatures.PERFORMANCE]: PERFORMANCE_ROUTES,
  [AvailableFeatures.COUNTERS]: COUNTERS_ROUTES,
  [AvailableFeatures.ENGINE_TRENDING]: ENGINE_TRENDING_ROUTES,
  [AvailableFeatures.ORGANIZATION_MANAGEMENT]: ORGANIZATION_MANAGEMENT_ROUTES,
} as const;

export { FEATURE_TO_ROUTES };
